import React from 'react';
const SvgAudioThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 100 100" width="1em" height="1em" {...props}>
      <path fill="#5C7896" d="M11 3v94h78V23H69V3H11z" />
      <path fill="#769CC2" d="M69 3l20 20H69V3z" />
      <path opacity={0.3} fill="#1B3F63" d="M69 23h20v20L69 23z" />
      <g fill="#FFF">
        <path d="M57.9 30.7c-.4.7-.1 1.6.5 2.1 5.8 4 9.6 10.6 9.6 18.2 0 7.9-4.1 14.8-10.3 18.7-.7.4-1 1.3-.6 2.1.4.7 1.2 1 1.9.6C66.2 67.9 71 60 71 51c0-8.7-4.4-16.3-11.1-20.7-.7-.5-1.6-.3-2 .4zM33 44h-5c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h5l11 9V35l-11 9z" />
        <path d="M53.6 38.4c-.4.7-.2 1.6.5 2.1 3.1 2.4 5.1 6.2 5.1 10.4 0 4.4-2.2 8.3-5.5 10.7-.7.5-.9 1.4-.6 2.1v.1c.4.7 1.2 1 1.9.5 4.3-2.9 7.1-7.8 7.1-13.4 0-5.3-2.6-10.1-6.6-13-.6-.4-1.5-.2-1.9.5z" />
        <path d="M49.6 53.5c-.5.7-.7 1.6-.4 2.3.4.7 1.2 1 1.8.4 1.4-1.3 2.3-3.2 2.3-5.3 0-2-.8-3.9-2.2-5.2-.6-.6-1.5-.4-1.8.4-.4.7-.2 1.7.3 2.3.5.7.8 1.6.8 2.5 0 1-.3 1.9-.8 2.6z" />
      </g>
    </svg>
  );
});
export default SvgAudioThumbnail;
SvgAudioThumbnail.iconName = 'audio-thumbnail';
SvgAudioThumbnail.displayName = 'SvgAudioThumbnail';
